// extracted by mini-css-extract-plugin
export default {"service_card":"KeyServiceCard_service_card__CHzMs","service_icon":"KeyServiceCard_service_icon__sNFon","service_btn":"KeyServiceCard_service_btn__w+1mM"};